import React, { Component } from "react";
import IntegratorCompanyUserTable from "./Table";
import CircularProgress from "material-ui/CircularProgress";
import styles from "styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCompanyUser } from "actions/integrators/integrators";
import { checkParams } from "../utils";

export class IntegratorCompanyUser extends Component {
  UNSAFE_componentWillMount() {
    const {
      params: { id = "", integratorId = "" } = {},
      getCompanyUser,
    } = this.props;
    checkParams(id);

    getCompanyUser(id, integratorId);
  }
  render() {
    const { isLoaded } = this.props;
    return (
      <div id="companies-list" className="table-page">
        <CircularProgress
          className={!isLoaded ? "" : "hidden"}
          style={styles.circularProgress}
        />

        <div className={isLoaded ? "" : "hidden"}>
          <div className="container-fluid">
            <h2>User's statistics</h2>
            <IntegratorCompanyUserTable />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ companyUser }) => {
    return {
      isLoaded: companyUser.isLoaded,
    };
  },
  (dispatch) =>
    bindActionCreators(
      {
        getCompanyUser,
      },
      dispatch
    )
)(IntegratorCompanyUser);



// WEBPACK FOOTER //
// ./app/components/Integrators/User/Page.jsx